import { GETDEFAULTTEMPLATES, GETUSERTEMPLATES, SAVETEMPLATE } from './urls';
import { localStorageSave, localStorageLoad } from './localStorage';
import { conn } from './conn';

const defaultTemplatesStorKey = 'default_templates';

const getDefaultTemplates = async (renew=false)=>{
  let ret = localStorageLoad(defaultTemplatesStorKey);
  // console.log('ret defaultemplate',ret);
  if(!ret || renew) {
    const { data } = await conn().get(GETDEFAULTTEMPLATES);
    localStorageSave({
      [defaultTemplatesStorKey]:data
    })
    ret=data;
  }

  if(!ret.templateId) {
    ret.templateId=ret._id;
  }
  return ret;
}


const saveTemplate = async (template)=>{

  const { data } = await conn().post(SAVETEMPLATE,template);

  console.log('template saved return',data);

  return data;
}


const getUserTemplates = async ()=>{
  const { data } = await conn().get(GETUSERTEMPLATES);
  return data;
}



const validateTemplate=(template)=>{
  const errorIds=[];
  const templateName=template.template.trim();
  const {categories}=template;
  if(!templateName) {
    errorIds.push('TITLE');
  }
  if(!categories.length) {
    errorIds.push('NO-CATEGORY');
  }
  categories.forEach(cat=>{
    const {_id,category,relevance,topics=[]}=cat;
    if( ! category || ! relevance || !topics.length) {
      errorIds.push(_id);
    }
    topics.forEach(topicElem=>{
      const {_id,topic,relevance}=topicElem;
      if( ! topic || ! relevance) {
        errorIds.push([cat._id,_id]);
      }
    });
  });

  return errorIds;
}

// used to filter/remove unwanted categories/topics ("Other")
const filterCategory=(catArray=[])=>{
  return catArray.filter(elem=>elem.category.toLowerCase!=='other');
}
const filterTopic=(topicArray=[])=>{
  return topicArray.filter(elem=>elem.topic.toLowerCase!=='other');
}

export {
  getDefaultTemplates,
  getUserTemplates,
  saveTemplate,
  validateTemplate,
  filterCategory,
  filterTopic
}